export function isHeaderOverlayOpen() {
  return Array.from(document.getElementsByClassName('sib-header-overlay')).some(node => {
    return node.classList.contains('sib-header-overlay-toggled');
  });
}
let n = 0;
export function generateUniqueId() {
  return n++;
}
export const throttle = (cb, delay) => {
  let isThrottled = false;
  let timerId;
  function execThrottle() {
    if (isThrottled) return;
    isThrottled = true;
    cb(...arguments);
    timerId = setTimeout(() => {
      isThrottled = false;
    }, delay);
  }
  function cancelThrottle() {
    clearTimeout(timerId);
  }
  return {
    execThrottle,
    cancelThrottle
  };
};
export const debounce = (cb, delay) => {
  let timerId;
  function execDebounce() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    let context = this;
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      cb.apply(context, ...args);
    }, delay);
  }
  function cancelDebounce() {
    clearTimeout(timerId);
  }
  return {
    execDebounce,
    cancelDebounce
  };
};
export const calculateAutoPosition = (triggerRef, bodyRef) => {
  var _triggerRef$current, _triggerRef$current2, _bodyRef$current, _bodyRef$current2;
  const left = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getBoundingClientRect().left;
  const bottom = (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getBoundingClientRect().bottom;
  const bodyHeight = (_bodyRef$current = bodyRef.current) === null || _bodyRef$current === void 0 ? void 0 : _bodyRef$current.clientHeight;
  const bodyWidth = (_bodyRef$current2 = bodyRef.current) === null || _bodyRef$current2 === void 0 ? void 0 : _bodyRef$current2.clientWidth;
  const spaceFromBottom = window.innerHeight - bottom;
  if (spaceFromBottom < bodyHeight) {
    if (left > bodyWidth) {
      return 'topRight';
    } else {
      return 'topLeft';
    }
  } else {
    if (left > bodyWidth) {
      return 'bottomRight';
    } else {
      return 'bottomLeft';
    }
  }
};